export const useAvatarProps = {
  color: { type: String, default: 'primary' },
  textColor: { type: String },
  square: { type: Boolean, default: false },
  fontSize: { type: String, default: '' },
}
